import { useGetAllConsignmentReportQuery } from "@states/report/report.api";
import { TSuccessResponse } from "@type-defs/general/TSuccessResponse";

const useGetAllConsignmentReport = (args: {
  page?: number;
  limit?: number;
  from_date?: string;
  to_date?: string;
  customer_id?: number;
  business_unit_id?: number;
}) => {
  const {
    data: rawData,
    error,
    isLoading,
    refetch,
    isFetching,
  } = useGetAllConsignmentReportQuery({ ...args });

  const consignmentReportResponse = rawData as any as TSuccessResponse<any>;

  return {
    consignmentReportData: consignmentReportResponse?.data,
    consignmentReportMessage: consignmentReportResponse?.message,
    consignmentReportSuccess: consignmentReportResponse?.success,
    consignmentReportPaginator: consignmentReportResponse?.paginator,
    consignmentReportError: error,
    consignmentReportLoading: isLoading,
    consignmentReportRefetch: refetch,
    consignmentReportFetching: isFetching,
  };
};

export default useGetAllConsignmentReport;
